
import { FC } from 'react'
import { useAppSelector } from '../../store/hooks'
import { Segment as SegmentModel } from '../../models/Segment'
import { selectSegmentById } from '../../store/SegmentReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'

type Props = SBModelComponent<SegmentModel> & {}

const SegmentOption: FC<Props> = ({ id, model }) => {
  const item = model ? model : useAppSelector(selectSegmentById(id!))

  if (!item) {
    return <></>
  }

  return item.title
}

type SegmentOptionType = { Option: typeof SegmentOption }

export { SegmentOption, type SegmentOptionType }
